<template>
      <div>
        <b-icon  icon="exclamation-triangle-fill" variant="dark" animation="throb" font-scale="4" />
        <hr>
        <div class="row">
            <div class="col-7">
                <p> 
                    Takip dışı olarak işaretlenmiş bir cihaz üzerinde işlem yapmayı deniyorsunuz. Önce cihazın geçmiş hareketlerini kontrol etmelisiniz. 
                </p>
                <p> 
                    Eğer cihazın önceki hareketlerinin doğru olduğundan eminseniz cihazın mevcut hareketleri ile birlikte takibe alabilirsiniz. Eğer ilgili bilgiler yanlış ise Geçmiş
                    Hareketleri silerek önce stok çıkışını doğru bilgiler ile yeniden yapıp daha sonra arıza girişini oluşturabilirsiniz.
                </p>
            </div>

            <div class="col-5">
                <strong> Cihazın Geçmiş Hareketleri</strong>
              
                <div class='steps' id='steps'>
                    <div class="step2" v-for="(info, i) in unTrackInfo" :key="i">
                        <div style="margin: 15px" > 
                            <b-badge :variant="info.record_type == 'out' ? 'danger'  : 'success'"> 
                                {{ info.record_type == 'out' ? 'Satış' : info.record_type == 'fault-out' ? 'Arıza Çıkışı' : info.record_type == 'fault-in' ? 'Arıza Girişi' : 'Alış'}}
                            </b-badge>
                        </div>
                        <div class='info'>
                        <p class='title'> {{ info.customer_name }} </p>
                        <p class='text'> {{ dateFormat(info.date)}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr /> 
      
       <p> <strong> Not: Burada yapacağınız işlemler cihazın garanti süresini belirleyecektir. Lütfen yanlış işlem yapmamaya özen gösteriniz.</strong> </p> 
        <validation-observer ref="UnTrack">
            <b-form class="formBox"> 
                <validation-provider name="İşlem"  :rules="{ required: true }" v-slot="validationContext" >
                    <b-form-group class="inputGrp">
                        <div class="elements" >
                            <Multiselect v-model="operation" :show-labels="false" :options="operations" label="text" track-by="val"  :state='getValidationState(validationContext)'>
                                <template slot="singleLabel" slot-scope="{ option }">
                                    <strong>{{ option.text }} </strong> 
                                </template>
                            </Multiselect>
                            <b-form-invalid-feedback id="live-feedback" style="display: block">
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                        </div>
                    </b-form-group>
                    
                </validation-provider>
            </b-form>
            
        </validation-observer>
       
   </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'
    import moment from 'moment'
    export default {
        name: "UnTrack",
        props:{
            data: Object,
            save: Boolean,
            saveState: Function,
            modalEvent: Function,
            modalName: String,
            sendRequest: Function,
        },
        components:{
            Multiselect
        },
        data: function(){
            return {
                operation: undefined,
                operations:[
                    {text: 'Cihazın Mevcut Hareketlerini Onayla', val: true },
                    {text: 'Cihazın Geçmiş Hareketlerini Sil', val: false},
                ]
            }
        },
        computed:{
            unTrackInfo: function(){
                return this.$store.getters.getUntrackInfo
            }
        },
        methods:{
            getValidationState({ dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            },
            dateFormat(val){
                return moment(String(val)).format('DD.MM.YYYY') 
            },
        },
        watch: {
            save: async function(data){
                if(data){
                    this.$refs.UnTrack.validate().then( async (success) => {
                        if(success){
                            let data = { serial_no: this.data.serial_number}
                            if(this.operation.val === true){
                                await this.$store.dispatch('untrack_remove', data)
                            }else if(this.operation.val === false){
                                await this.$store.dispatch('movement_remove', data)
                            }
                            if(this.$store.getters.getStockStatus.status == 'Success'){
                                let text = this.operation.val ? 'Cihazın önceki hareketleri onaylanmış ve takibe alınmıştır. Arıza girişini yeniden yapabilirsiniz' : 'Cihazın önceki hareketleri silinmiştir. Lütfen önce doğru stok çıkışını yapınız daha sonra arıza girişi oluşturabilirsiniz.'
                                this.$bvToast.toast( text , {
                                    title: 'DİKKAT!',
                                    variant: 'warning',
                                    solid: true
                                })
                                this.modalEvent(false)
                            }
                        }
                    })
                }
               
                this.saveState(false)
            }
        }
    }
</script>

<style scoped>
  @import "../styles/faultSupportDetail.min.css";
</style>


// WEBPACK FOOTER //
// src/pages/ERP/Stock/modals/UnTrack.vue